import { LoginResponse } from 'generated/iTypes'

export const getUserToken = (): LoginResponse => {
  let ret: LoginResponse = {}
  const lsToken = localStorage.getItem('token')
  if (lsToken) ret = JSON.parse(lsToken) as LoginResponse
  return ret
}
